import { __rest } from 'tslib';
import React__default from 'react';
import { AccountFilled, RewardBronzeCircleColored, RewardSilverCircleColored, RewardGoldenCircleColored, RewardPlatinumCircleColored } from '@teko/ds-icon';
import { CommonStyles } from '../BaseProps/index.es.js';
import styled from '@emotion/styled';

const MAPPING_SIZE = {
    s: 24,
    m: 32,
    l: 40,
    xl: 48,
};
const MAPPING_REWARD_COMPONENT = {
    bronze: RewardBronzeCircleColored,
    silver: RewardSilverCircleColored,
    gold: RewardGoldenCircleColored,
    platinum: RewardPlatinumCircleColored,
};
const Wrapper = styled.span `
  ${CommonStyles}
  position: relative;
  border-radius: 50%;
  width: ${(p) => p.size}px;
  height: ${(p) => p.size}px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${(p) => p.backgroundColor ? p.theme.colors[p.backgroundColor] : 'unset'};
`;
const TextIcon = styled.span `
  display: inline-block;
  font-size: ${(p) => p.size / 2}px;
  color: ${(p) => p.theme.colors[p.color]};
  text-align: center;
`;
const ImageIcon = styled.img `
  object-fit: cover;
  border-radius: 50%;
`;
const RewardIcon = styled.div `
  display: flex;
  position: absolute;
  bottom: 0;
  right: 0;
  background: transparent;
`;
const Avatar = (_a) => {
    var { size = 'm', text, icon, src, color = 'textSecondary', backgroundColor = 'disable', showReward = false, rewardType = 'gold', customRewardIcon } = _a, props = __rest(_a, ["size", "text", "icon", "src", "color", "backgroundColor", "showReward", "rewardType", "customRewardIcon"]);
    const actualSize = typeof size === 'string' ? MAPPING_SIZE[size] : size;
    const renderChildren = () => {
        var _a, _b, _c, _d;
        if (!icon && !src && !text) {
            return React__default.createElement(AccountFilled, { color: "disable", size: actualSize });
        }
        if (!!src) {
            return (React__default.createElement(ImageIcon, { src: src, width: actualSize, height: actualSize, alt: "avtSrc" }));
        }
        if (icon) {
            return React__default.cloneElement(icon, {
                size: !((_a = icon === null || icon === void 0 ? void 0 : icon.props) === null || _a === void 0 ? void 0 : _a.size) ? actualSize : (_b = icon === null || icon === void 0 ? void 0 : icon.props) === null || _b === void 0 ? void 0 : _b.size,
                color: !((_c = icon === null || icon === void 0 ? void 0 : icon.props) === null || _c === void 0 ? void 0 : _c.color) ? color : (_d = icon === null || icon === void 0 ? void 0 : icon.props) === null || _d === void 0 ? void 0 : _d.color,
            });
        }
        if (!!text.length) {
            return (React__default.createElement(TextIcon, { size: actualSize, color: color }, text[0]));
        }
    };
    const renderReward = () => {
        var _a, _b;
        if (!showReward && !customRewardIcon)
            return null;
        if (customRewardIcon)
            return (React__default.createElement(RewardIcon, null, React__default.cloneElement(customRewardIcon, {
                size: !((_a = customRewardIcon === null || customRewardIcon === void 0 ? void 0 : customRewardIcon.props) === null || _a === void 0 ? void 0 : _a.size)
                    ? actualSize / 3
                    : (_b = customRewardIcon === null || customRewardIcon === void 0 ? void 0 : customRewardIcon.props) === null || _b === void 0 ? void 0 : _b.size,
            })));
        const Comp = MAPPING_REWARD_COMPONENT[rewardType];
        return (React__default.createElement(RewardIcon, null,
            React__default.createElement(Comp, { size: actualSize / 3 })));
    };
    return (React__default.createElement(Wrapper, Object.assign({}, props, { size: actualSize, backgroundColor: !!(text === null || text === void 0 ? void 0 : text.length) && backgroundColor }),
        renderChildren(),
        renderReward()));
};

export { Avatar };
